import React, { ElementType, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import useMediaQuery from '@/hooks/useMediaQuery'
import { cn } from '@/lib/utils'
import { RoutePath } from '@/routes'

import { Flex, Grid } from '../common/Box'
import DropdownMenu from '../common/DropdownMenu'
import { Text } from '../common/Text'
import { IconCreate, Tabs } from '../svgr'

const TabNavs: React.FC = () => {
  const { gtLG } = useMediaQuery()
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const [open, setOpen] = useState(false)

  const renderTab = useCallback(
    (
      Icon: ElementType,
      name: string,
      paths: RoutePath | Array<{ title: string; path: RoutePath }>,
      option?: { isCreate?: boolean; isSoon?: boolean }
    ) => {
      if (typeof paths === 'string')
        return (
          <NavLink
            onClick={(ev) => {
              if (option?.isSoon) ev.preventDefault()
            }}
            to={paths}
            className={cn(
              'mt-1 flex flex-col items-center justify-center',
              pathname === paths && 'text-primary',
              option?.isSoon && 'relative'
            )}
          >
            {option?.isSoon && (
              <div className="absolute -right-1 -top-1 scale-50 rounded-md rounded-bl-none bg-primary p-1 leading-none">
                soon
              </div>
            )}
            <Icon
              className={cn(
                'size-5',
                option?.isCreate && 'origin-bottom scale-[250%]',
                option?.isSoon && 'opacity-60'
              )}
            />
            <Text
              className={cn(
                'text-xs text-inherit',
                option?.isSoon && 'opacity-60'
              )}
            >
              {name}
            </Text>
          </NavLink>
        )
      return (
        <DropdownMenu
          open={open}
          onOpenChange={setOpen}
          trigger={{
            children: (
              <Flex
                className={cn(
                  'flex flex-col items-center justify-center',
                  paths
                    .map(({ path }) => path)
                    .includes(pathname as RoutePath) && 'text-primary'
                )}
              >
                <Icon
                  className={cn(
                    'size-5',
                    option?.isCreate && 'origin-bottom scale-[250%]'
                  )}
                />
                <Text className="text-sm text-inherit">{name}</Text>
              </Flex>
            )
          }}
          content={{
            align: 'center',
            className:
              'border-white/10 bg-white/5 p-2 backdrop-blur-md w-auto min-w-fit'
          }}
        >
          <Grid>
            {paths.map((child) => (
              <NavLink
                key={child.path}
                to={child.path}
                className={cn(
                  'block rounded-md p-2 text-left leading-none hover:bg-primary',
                  pathname === child.path && 'bg-primary'
                )}
                onClick={() => setOpen(false)}
              >
                {child.title}
              </NavLink>
            ))}
          </Grid>
        </DropdownMenu>
      )
    },
    [open, pathname]
  )

  if (gtLG) return null
  if (
    ![
      RoutePath.HOME,
      RoutePath.AIRDROP,
      RoutePath.CREATE,
      RoutePath.STAKING,
      RoutePath.MINING_PLATFORM,
      RoutePath.MINING_INFLUENCE,
      RoutePath.PROPOSAL
    ].includes(pathname as RoutePath)
  )
    return null
  return (
    <>
      <div className="h-16" />
      <Grid className="fixed bottom-0 left-0 right-0 z-10 h-[52px] grid-cols-5 bg-background">
        {renderTab(Tabs.Home, t('nav.home'), RoutePath.HOME)}
        {renderTab(Tabs.Mining, t('nav.mining'), RoutePath.MINING_PLATFORM)}
        {renderTab(IconCreate, 'Create', RoutePath.CREATE, { isCreate: true })}
        {renderTab(Tabs.Staking, t('nav.staking'), RoutePath.STAKING)}
        {/* {renderTab(Tabs.Airdrop, t('nav.airdrop'), RoutePath.AIRDROP)}
        {renderTab(IconCreate, 'Create', RoutePath.CREATE, { isCreate: true })}
        {renderTab(Tabs.Mining, t('nav.mining'), RoutePath.MINING_PLATFORM)} */}
        {/* {renderTab(Tabs.Earning, t('nav.earn'), [
          {
            title: t('nav.staking'),
            path: RoutePath.STAKING
          },
          {
            title: t('nav.mining'),
            path: RoutePath.MINING_PLATFORM
          },
          {
            title: t('nav.mining.influence'),
            path: RoutePath.MINING_INFLUENCE
          }
        ])} */}
        {renderTab(Tabs.Proposals, t('nav.proposals'), RoutePath.PROPOSAL, {
          isSoon: true
        })}
      </Grid>
    </>
  )
}

export default TabNavs
